import { render } from "./FiLabelSub.vue?vue&type=template&id=215a44d4&scoped=true&ts=true"
import script from "./FiLabelSub.vue?vue&type=script&lang=ts"
export * from "./FiLabelSub.vue?vue&type=script&lang=ts"

import "./FiLabelSub.vue?vue&type=style&index=0&id=215a44d4&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215a44d4"]])

export default __exports__